import { render, staticRenderFns } from "./ReportAssignModal.vue?vue&type=template&id=0a055336&"
import script from "./ReportAssignModal.vue?vue&type=script&lang=js&"
export * from "./ReportAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports